import { useUpdateStandardProductOrder } from "app/hooks/checkout/useUpdateStandardProductOrder";
import { useCartContext } from "app/providers/CartProvider";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { toast } from "react-toastify";
import { STORAGE_ORDER_KEY } from "shared/config";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";

const CheckoutPanelCalendarFooter = () => {
  // const createBumbalDateMutation = useCreateStandardOrderBumbalDate();
  const { updateCurrentTab } = useCheckoutTabsContext();
  const { getCart, resetCart } = useCartContext();
  const cart = getCart();
  const { updateOrderAsync, isUpdateLoading } = useUpdateStandardProductOrder();

  const onProceedClick = async () => {
    const orderId = localStorage.getItem(STORAGE_ORDER_KEY);
    if (!orderId) {
      toast.error(
        "Er is een fout opgetreden. Neem contact op met de ondersteuning",
      );
      return;
    }

    try {
      if (cart.pickupWarehouse) {
        // Take the values from the calendar
        const payload = {
          delivery: {
            type: cart.delivery.type,
            date: new Date(cart.delivery.date).toISOString(),
          },
        };

        // Update delivery date in the order
        await updateOrderAsync(orderId, payload);
      }
      updateCurrentTab(CheckoutTabIds.PAYMENT);
    } catch (error) {
      toast.error(
        "Er is een fout opgetreden. Neem contact op met de ondersteuning",
      );
    }
  };

  const canProceed = () => {
    return cart.delivery.date;
  };

  return (
    <footer
      className={concatClassnames(
        "gg-px-4 sm:gg-px-14 md:gg-px-16 lg:gg-px-14 xl:gg-px-14 2xl:gg-px-32",
        "gg-grid gg-gap-y-5 gg-bg-dark-blue gg-py-11 gg-text-white",
        "gg-items-center sm:gg-flex sm:gg-justify-between sm:gg-gap-x-8",
      )}
    >
      <Button
        type={ButtonTypes.WHITE}
        arrow={ButtonArrowTypes.LEFT}
        onClick={() => updateCurrentTab(CheckoutTabIds.APPOINTMENT)}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-w-fit lg:gg-max-w-xs xl:gg-py-3.5"
      >
        Terug naar afspraak
      </Button>

      <Button
        type={ButtonTypes.YELLOW}
        arrow={ButtonArrowTypes.RIGHT}
        onClick={() => onProceedClick()}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-w-fit lg:gg-px-10 xl:gg-py-3.5"
        disabled={!canProceed() || isUpdateLoading}
        loading={false}
      >
        Betalen
      </Button>
    </footer>
  );
};
export default CheckoutPanelCalendarFooter;
